import styled from '~/app/components/styled'
import { Renderable } from './index'
import { Typography } from '@yanolja-org/ya-com-core'
import CollapseContainer from '~/app/components/common/CollapseContainer'

// type definitions
export type CouponContentProps = {
  title: Renderable
  coupons: { title: string; price: string; couponType: string }[]
  isShow?: boolean
}

const Body = styled.div`
  padding: 0 2rem;
  color: ${({ theme }) => theme.color.gray600};
  ${Typography('body2').regular};
`

const Title = styled.div`
  padding: 0.8rem 0;
`

const Coupon = styled.div`
  padding: 0.4rem 0 0.4rem 1.6rem;
  display: flex;
  justify-content: space-between;
`

const CouponContent: React.FunctionComponent<CouponContentProps> = function ({
  title,
  coupons,
  isShow = true,
}) {
  return (
    <CollapseContainer isShow={isShow}>
      <Body>
        <Title>• {title}</Title>
        <div>
          {coupons.map((coupon, index) => (
            <Coupon key={index}>
              <span>{coupon.title}</span>
              <span>{coupon.price}</span>
            </Coupon>
          ))}
        </div>
      </Body>
    </CollapseContainer>
  )
}

export default CouponContent
